export const environment = {
  production: false,
  loginType: 'video',
  title: '[PRE] Glocally Last Mile',
  footerUrl: 'https://www.glocally.eu/',
  copyrightText: '©2022 Todos los derechos reservados. Glocally. From Global to Local.'
};
